import React, { useEffect } from 'react';
import Drawer from '@mui/material/Drawer';
import ProductEditForm from '../ProductEditForm';
import { ConfigProvider } from 'antd';

const ProductEditDrawer = ({ open, onClose, showMessage }) => {
    useEffect(() => {
        if (open) {
            // Only fix z-index for dropdowns
            const style = document.createElement('style');
            style.textContent = `
                .ant-select-dropdown {
                    z-index: 9999 !important;
                }
                .ant-color-picker-dropdown {
                    z-index: 10000 !important;
                }
            `;
            document.head.appendChild(style);
            
            return () => {
                document.head.removeChild(style);
            };
        }
    }, [open]);

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            ModalProps={{
                container: document.body,
                style: { 
                    position: 'fixed',
                    zIndex: 1300,
                },
                disableScrollLock: true,
            }}
            sx={{
                '& .MuiDrawer-paper': {
                    width: "850px",
                    boxSizing: 'border-box',
                    overflow: 'auto',
                },
            }}
        >
            {/* Wrap ProductUploadForm with ConfigProvider */}
            <ConfigProvider
                getPopupContainer={(triggerNode) => {
                    return triggerNode?.parentNode || document.body;
                }}
                dropdownMatchSelectWidth={false}
            >
                <div style={{ 
                    width: "100%", 
                    height: '100vh', 
                    overflowY: 'auto',
                    scrollbarGutter: "stable both-edges",
                    position: 'relative',
                }}>
                    <ProductEditForm showMessage={showMessage} />
                    
                </div>
            </ConfigProvider>
        </Drawer>
    );
};

export default ProductEditDrawer;